import axios from 'axios'

const baseURL = import.meta.env.VITE_API_BASE_URL || '/api'

export const apiClient = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 20_000,
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    const url = error?.config?.url || ''
    const data = error?.response?.data
    const message =
      (typeof data === 'object' && (data?.message || data?.error)) ||
      (typeof data === 'string' ? data : null) ||
      error.message ||
      'Request failed'
    error.uiMessage = message
    if (status === 401 && !url.includes('/auth/')) {
      window.dispatchEvent(new CustomEvent('arrow:unauthorized'))
    }
    return Promise.reject(error)
  },
)
